// extracted by mini-css-extract-plugin
export var displayNone = "_q5-6";
export var imgContainer = "_q5-2";
export var overflowHidden = "_q5-3";
export var productInfoCardButtonContainer = "_q5-5";
export var productTitleText = "_q5-4";
export var rightArrow = "_q5-1";
export var rightArrowContainer = "_q5-0";